export default __webpack_public_path__ + "static/media/arrow_open.30d6f080.svg";